import { useEffect } from 'react';
import { Checkbox, Col, DatePicker, Form, Input, Modal, Row, Space } from 'antd';
import dayjs from 'dayjs';
import _ from 'lodash';
import moment from 'moment';
import { dateToDayjs, dateToStringWT } from '@/utils';
import { useGetAgenciesQuery, useGetHomeStudyStatusQuery, useGetHomeStudyTypesQuery } from '@/services/general-api';
import { useSaveParentHomeStudyMutation } from '@/services/parent-api';
import Select from '@/components/select';

const EditModal = ({ parentId, open, data, refetch, onClose }) => {
  const { data: statusData, isLoading: loadingStatusData } = useGetHomeStudyStatusQuery();
  const { data: agencyData, isLoading: loadingAgencyData } = useGetAgenciesQuery();
  const { data: typeData, isLoading: loadingTypeData } = useGetHomeStudyTypesQuery();
  const [saveHomeStudy, { isLoading: saving }] = useSaveParentHomeStudyMutation();
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        form.resetFields();
      });
    }
  }, [open, form]);

  const onFinish = async (body) => {
    if (body.meetingScheduled) {
      body.meetingScheduledSetOn = data.meetingScheduledSetOn || dateToStringWT(dayjs());
    }
    if (body.completed?.date) {
      body.completed = {
        year: body.completed.date.get('year'),
        month: body.completed.date.get('month') + 1,
        day: body.completed.date.get('date'),
      };
    }

    try {
      await saveHomeStudy({ parentId, body }).unwrap();

      refetch();
      onClose();
    } catch (err) {}
  };

  return (
    <>
      <Modal
        title="Edit Family Status"
        open={open}
        okText="Save"
        confirmLoading={saving}
        onOk={() => form.submit()}
        onCancel={onClose}
        width={800}
      >
        <Form
          layout="vertical"
          form={form}
          initialValues={{
            ...data,
            completed: {
              date: dateToDayjs(data.completed.date),
            },
          }}
          onFinish={onFinish}
        >
          <Row gutter={24}>
            <Col xs={24} md={12}>
              <Form.Item name={['status', 'id']} label="Status" rules={[{ required: true }]}>
                <Select
                  options={statusData}
                  loading={loadingStatusData}
                  showSearch
                  onChange={() => {
                    form.setFieldValue(['type', 'id'], undefined);
                    form.setFieldValue(['completed', 'date'], undefined);
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item name={['agency', 'id']} label="Agency">
                <Select options={agencyData} loading={loadingAgencyData} showSearch />
              </Form.Item>
            </Col>

            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) => prevValues.status?.id !== currentValues.status?.id}
            >
              {({ getFieldValue }) => {
                const statusCode = _.find(statusData, { id: getFieldValue('status')?.id })?.code;
                return (
                  statusCode === 'hs-completed' && (
                    <>
                      <Col xs={24} md={12}>
                        <Form.Item name={['type', 'id']} label="Type" rules={[{ required: true }]}>
                          <Select options={typeData} loading={loadingTypeData} showSearch />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={12}>
                        <Form.Item name={['completed', 'date']} label="Completed" rules={[{ required: true }]}>
                          <DatePicker
                            format="MM/DD/YYYY"
                            onBlur={(e) => {
                              const inputVal = e.target.value;
                              const validDate = moment(inputVal, ['M/D/YYYY', 'MM/DD/YYYY'], true);
                              if (validDate.isValid()) {
                                form.setFieldsValue({
                                  completed: { ...form.completed, date: validDate },
                                });
                              } else {
                                form.setFieldsValue({
                                  completed: { ...form.completed, date: null },
                                });
                              }
                            }}
                          />
                        </Form.Item>
                      </Col>
                    </>
                  )
                );
              }}
            </Form.Item>
          </Row>
          <div>RAPT</div>
          <Space size="middle">
            <Form.Item name="homeStudyOrientation1" valuePropName="checked">
              <Checkbox>Orientation</Checkbox>
            </Form.Item>
            <Form.Item name="meetingScheduled" valuePropName="checked">
              <Checkbox>Meeting Scheduled</Checkbox>
            </Form.Item>
            <Form.Item name="homeStudyRAPT4" valuePropName="checked">
              <Checkbox>Completed RAPT IV</Checkbox>
            </Form.Item>
          </Space>

          <Form.Item name="notes" label="Notes" className="m-0">
            <Input.TextArea autoSize={{ minRows: 3 }} />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default EditModal;
